/**
 * @fileoverview Esqueci a senha (30/10/2026, etapa 4 dos planos): o e-mail da
 * conta; o link para criar uma nova senha chega por e-mail e vale 1 hora. A
 * resposta é a mesma exista ou não a conta.
 */

import React, { useState } from "react";
import { Link as RouterLink, useHistory } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";

import { i18n } from "../../translate/i18n";
import { openApi } from "../../services/api";
import toastError from "../../errors/toastError";
import AuthLayout from "../../components/AuthLayout";
import useLanguage from "../../hooks/useLanguage";
import { useAuthFormStyles } from "../../components/AuthLayout/formStyles";
import { EMAIL_RE } from "../../components/AuthLayout/authHelpers";

const ForgotPassword = () => {
  useLanguage(); // trocou o idioma no globo: redesenha já traduzida
  const classes = useAuthFormStyles();
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);
  const [sentTo, setSentTo] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (sending) return;
    if (!EMAIL_RE.test(email.trim())) {
      setError(i18n.t("login.errors.emailInvalid"));
      return;
    }
    setSending(true);
    try {
      await openApi.post("/auth/password/forgot", { email: email.trim() });
      setSentTo(email.trim());
    } catch (err) {
      toastError(err);
    } finally {
      setSending(false);
    }
  };

  return (
    <AuthLayout>
      {sentTo ? (
        <div className={classes.view}>
          <h1 className={classes.title}>{i18n.t("auth.checkEmailTitle")}</h1>
          <div className={classes.notice} role="status">{i18n.t("auth.forgot.sent", { email: sentTo })}</div>
          <button type="button" className={classes.secondary} onClick={() => history.push("/login")}>{i18n.t("auth.backToLogin")}</button>
        </div>
      ) : (
        <form className={classes.view} noValidate onSubmit={submit}>
          <h1 className={classes.title}>{i18n.t("auth.forgot.title")}</h1>
          <p className={classes.subtitle}>{i18n.t("auth.forgot.subtitle")}</p>
          <div className={classes.field}>
            <label className={classes.label} htmlFor="forgot-email">{i18n.t("auth.fields.email")}</label>
            <input id="forgot-email" type="email" className={classes.input} value={email} autoComplete="email" autoFocus
              onChange={(e) => { setEmail(e.target.value); setError(""); }}
              aria-invalid={Boolean(error)} aria-describedby={error ? "forgot-email-error" : undefined} />
            {error && <div id="forgot-email-error" className={classes.error}>{error}</div>}
          </div>
          <button type="submit" className={classes.button} disabled={sending} style={{ marginTop: 8 }}>
            {sending && <CircularProgress size={18} className={classes.spinner} />}
            {i18n.t("auth.forgot.submit")}
          </button>
          <div className={classes.alt}>
            <RouterLink to="/login" className={classes.link}>{i18n.t("auth.backToLogin")}</RouterLink>
          </div>
        </form>
      )}
    </AuthLayout>
  );
};

export default ForgotPassword;
